class Session {
    id = null;
    session_type_id = null;
    room_id = null;
    trainer_id = null;
    date = null;
    start_time = '';
    end_time = '';
    repeatable = false;
    repeatable_data = [];
    repeatable_start_date = null;
    repeatable_end_date = null;

    constructor(data) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default Session;
